type DividerProps = {
  children?: React.ReactNode;
  axis?: 'horizontal' | 'vertical';
};

export const Divider = ({ children, axis = 'horizontal' }: DividerProps) => {
  return (
    <div className="relative">
      <div aria-hidden="true" className="absolute inset-0 flex items-center">
        <div
          className={axis === 'horizontal' ? 'w-full border-t border-gray-200' : 'h-full border-l border-gray-200'}
        />
      </div>
      {!!children && (
        <div className="relative flex pl-8">
          <div className="bg-white">{children}</div>
        </div>
      )}
    </div>
  );
};
